export const CicChangeColumnId = {
  FIELD: 'field',
  CHANGE: 'change',
  REASON: 'reason',
  COMMENT: 'comment',
  ENTERED_BY: 'enteredBy',
  ACTIONS: 'actions',
};
